import { Loading } from "@/components/common/Loading";
import { RemunerationService } from "@/service/services/Remuneration.service";
import { readLocalStorage, removeLocalStorage } from "@/toolbox/helpers/local-storage-helper";
import { Alert, Autocomplete, Button, Container, Grid, Snackbar, TextField } from "@mui/material";
import { useState } from "react";
import { Props } from "./PDF.type"


export const PDFView: React.FC<Props> = (props:any): JSX.Element => {
    // const { pdf, dataRemu, idEmploye } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [btnSave, setBtnSave] = useState<boolean>(true);
    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });

    const [departments, setDepartments] = useState<any>([]);
    const [departmentSelected, setDepartmentSelected] = useState<any>('');
    const [charges, setCharges] = useState<any>([]);
    const [chargeSelected, setChargeSelected] = useState<any>('');
    const [costCenters, setCostCenters] = useState([]);
    const [costCentersSelected, setCostCentersSelected] = useState<any>('');

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const param = urlParams.get('type');

    const data = readLocalStorage('dataRemu');
    const dataIdEmployee = data?.idemployee;
    const dataPDF = data?.pdf;
    const dataRemu = {
        idperiod: data?.idperiod,
        month: data?.month,
        year: data?.year
    }

    const onSubmit = async() => {
        setLoading(true);
        const resp:any = await RemunerationService.createRemuneration(dataRemu, dataIdEmployee);
        if(resp.data.status == true){
            setBtnSave(false);
            setLoading(false);
            // removeLocalStorage('dataRemu');
            return (
                setSnackBarConfig(prev => ({ ...prev, open: true, 
                severity:'success', 
                message: `${resp.data.message}` }
                ))
            );
        }
    }

    const dataMassive = readLocalStorage('dataRemuMassive');
    const dataPDFMassive = dataMassive?.pdf;
    console.log(dataMassive)

    const createLiquidationMasive = async () => {
        setLoading(true);
        const dataLiquidationMasive = {
           idperiod: dataMassive?.idperiod,
           month: dataMassive?.month,
           year: dataMassive?.year,
           idproject: dataMassive?.idproject,
           idbusinessarea: dataMassive?.idbusinessarea,
           idcharge: dataMassive?.idcharge,
           idcostcenter: dataMassive?.idcostcenter
        }
  
        const response = await RemunerationService.createRemunerationMassive(dataLiquidationMasive);
        if (response.data.status == true) {
           setSnackBarConfig(prev => ({
              ...prev, open: true,
              severity: 'success',
              message: `${response.data.message}`
              }
           ));
        } else {
           setSnackBarConfig(prev => ({
              ...prev, open: true,
              severity: 'warning',
              message: `${response.data.message}`
              }
           ));
        }
        setLoading(false);
     }

    return (
        <>
        {loading && <Loading/>}
        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

        <Grid container style={{ overflow: 'hidden !important', height:'100%', alignItems: 'center', textAlign: 'center'}}>
            {
                !param && btnSave && (
                    <Grid container display='flex' justifyContent='center' style={{margin: '10px', overflow: 'hidden'}} >
                        <Button onClick={onSubmit} size="small" color={"primary"} variant="contained" >
                        {`crear remuneracion`}
                        </Button>
                    </Grid>
                )
            }
            {
                param && param == 'massive' && (
                    <Grid container display='flex' justifyContent='center' style={{margin: '10px', overflow: 'hidden'}} >
                        <Button onClick={createLiquidationMasive} size="small" color={"primary"} variant="contained" >
                        {`crear remuneracion masiva`}
                        </Button>
                    </Grid>
                )
            }
            <iframe src={param && param == 'massive' ? dataPDFMassive : dataPDF} id="pdfVer" height="1000px" width="100%"></iframe>
        </Grid>
        </>
    )
}